// SkipMarker — small red × that surfaces wherever a party's name
// renders, once the operator has flagged them "not worth pursuing"
// via the toggle on PartyDetail. Reads mi.parties.skipped_at.
//
// Variants:
//   - 'inline' (default): small red ×, sits next to the name in dense
//                         rosters. Hover shows the skip date.
//   - 'badge':            larger chip ("× not worth pursuing"). Used on
//                         the PartyDetail header.

interface SkipMarkerProps {
  skippedAt: string | null;
  variant?: 'inline' | 'badge';
  className?: string;
}

export function SkipMarker({ skippedAt, variant = 'inline', className = '' }: SkipMarkerProps) {
  if (!skippedAt) return null;

  const date = skippedAt.slice(0, 10);
  const tooltip = `Marked not worth pursuing on ${date}`;

  if (variant === 'badge') {
    return (
      <span
        title={tooltip}
        className={
          'inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider rounded border border-red/40 bg-red/10 text-red ' +
          className
        }
      >
        <span>×</span>
        not worth pursuing
      </span>
    );
  }

  return (
    <span
      title={tooltip}
      className={'inline-block text-red font-bold text-[12px] leading-none align-middle ' + className}
      aria-label={tooltip}
    >
      ×
    </span>
  );
}
